import { render, staticRenderFns } from "./XhTextarea.vue?vue&type=template&id=5540b29b&scoped=true"
import script from "./XhTextarea.vue?vue&type=script&lang=js"
export * from "./XhTextarea.vue?vue&type=script&lang=js"
import style0 from "./XhTextarea.vue?vue&type=style&index=0&id=5540b29b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540b29b",
  null
  
)

export default component.exports